import { Link } from "react-router-dom";
import { NavigationMenuItem, NavigationMenuLink, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Briefcase, Users, Palette } from "lucide-react";
import { SparklesCore } from "@/components/ui/sparkles";
import { useTranslation } from "react-i18next";

interface NavigationLinksProps {
  subscription: { tier: string } | null;
}

export const NavigationLinks = ({ subscription }: NavigationLinksProps) => {
  const { t } = useTranslation();

  return (
    <>
      <NavigationMenuItem>
        <Link to="/opportunities">
          <NavigationMenuLink className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors`}>
            <div className="relative flex items-center overflow-visible group">
              <Briefcase className="mr-2 h-4 w-4" />
              <div className="relative">
                <span className="relative z-10">{t('nav.opportunities')}</span>
                
                <div className="absolute inset-x-0 top-full z-20 bg-gradient-to-r from-transparent via-primary to-transparent h-[2px] w-full blur-sm" />
                <div className="absolute inset-x-0 top-full z-20 bg-gradient-to-r from-transparent via-primary to-transparent h-px w-full" />
                <div className="absolute inset-x-0 top-full z-20 bg-gradient-to-r from-transparent via-secondary to-transparent h-[5px] w-3/4 blur-sm mx-auto" />
                <div className="absolute inset-x-0 top-full z-20 bg-gradient-to-r from-transparent via-secondary to-transparent h-px w-3/4 mx-auto" />
                
                <div className="absolute -z-0 left-0 right-0 top-[calc(100%+1px)] h-5 overflow-hidden">
                  <SparklesCore 
                    className="w-full h-full"
                    particleColor="#FF6B6B"
                    number={{
                      density: {
                        enable: true,
                        width: 200,
                        height: 15
                      },
                      value: 15
                    }}
                    speed={0.4}
                    minSize={0.4}
                    maxSize={1}
                    background="transparent"
                  />
                  <div className="absolute inset-0 w-full h-full bg-background [mask-image:radial-gradient(100px_30px_at_top,transparent_30%,white)]" />
                </div>
              </div>
            </div>
          </NavigationMenuLink>
        </Link>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Link to="/feed">
          <NavigationMenuLink className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors`}>
            <Palette className="mr-2 h-4 w-4" />
            <span>{t('nav.feed')}</span>
          </NavigationMenuLink>
        </Link>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <Link to="/directory">
          <NavigationMenuLink className={`${navigationMenuTriggerStyle()} border border-input bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors`}>
            <Users className="mr-2 h-4 w-4" />
            <span>{t('nav.directory')}</span>
          </NavigationMenuLink>
        </Link>
      </NavigationMenuItem>
    </>
  );
};